module.exports = __webpack_public_path__ + "img/18_13.c6c54de6.png";